import { get, post, upload, remove } from './api';
import routes from './end-points';

export const PaymentDocumentApi = {
  initSenderPaymentDocuments: () => get(routes.paymentDocument.initSenderPaymentDocuments),
  initSenderPaymentDocument: (paymentDocumentDepositorId) =>
    get(routes.paymentDocument.initSenderPaymentDocument(paymentDocumentDepositorId)),
  initMinePaymentDocument: (userfundId) => get(routes.paymentDocument.initMinePaymentDocument(userfundId)),
  setPaymentDocumentBankId: (dto) => post(routes.paymentDocument.setPaymentDocumentBankId, dto),
  sendDocumentForPayment: (id) => get(routes.paymentDocument.sendDocumentForPayment(id)),
  deleteReceipt: (id) => remove(routes.paymentDocument.deleteReceipt(id)),
  uploadReceipt: (dto) => {
    const form_data = new FormData();
    form_data.append('file', dto.file);
    for (const [key, value] of Object.entries(dto)) form_data.append(key, value);
    return upload(routes.paymentDocument.uploadReceipt, form_data);
  },
  receiptDownloadUrl: (id) => routes.paymentDocument.receiptDownloadUrl(id),
};
